<div class="card h-100">
  <div class="card-header d-flex justify-content-between align-items-center border-0 bg-transparent p-3">
    <div>
      <h5 class="card-title mb-0 d-flex align-items-center gap-2">
        Ticket Dispositions
        <kendo-svg-icon
          [icon]="infoCircleIcon"
          size="small"
          class="info-icon"
          kendoTooltip
          title="Provides a clear view of how SOC escalations conclude, helping identify response trends and areas for process optimization."
        ></kendo-svg-icon>
      </h5>
      <p class="text-muted small mb-0">Distribution of ticket resolution types</p>
    </div>
    <kendo-dropdownbutton
      kendoButton
      [svgIcon]="moreVerticalIcon"
      fillMode="flat"
      size="small"
      [data]="[{ text: 'View Data' }]"
      (itemClick)="onContextMenuSelect({ text: 'View Ticket Data' }, '')"
    ></kendo-dropdownbutton>
  </div>
  <div class="card-body p-0">
    <div class="list-group list-group-flush">
      @for (disposition of formattedDispositions(); track disposition.disposition) {
        <div class="list-group-item d-flex justify-content-between align-items-center py-2 px-3">
          <span class="text-truncate me-2">{{ disposition.disposition }}</span>
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted small">{{ disposition.formattedPercentage }}%</span>
            <span
              class="badge"
              [class]="'bg-' + getCountSeverity(disposition.percentage)"
            >
              {{ disposition.formattedCount }}
            </span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
<!-- Reusable Ticket Data Dialog -->
@if (ticketDialogConfig()) {
  <app-ticket-data-dialog
    [config]="ticketDialogConfig()!"
    [visible]="showTicketDialog()"
    (close)="onTicketDialogClose()"
    (exportCsv)="triggerExport()"
  />
}
